import userService from "@/endpoints/userService";
import ShowToaster from "@/toaster";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const updateBrandColor = createAsyncThunk<
  { brandId: number; color: string } | null,
  { brandId: number; marketId: number; userId: number; color: string },
  { rejectValue: string }
>(
  "brands/updateColor",
  async ({ brandId, color, marketId, userId }, thunkAPI) => {
    try {
      const response: string = (await userService.brands.updateBrandColor({
        brandId,
        userId,
        marketId,
        color,
      })) as any;
      return response ? { brandId, color } : null;
    } catch (err: any) {
      ShowToaster.error("Failed to update brand color.");
      return thunkAPI.rejectWithValue(
        "Failed to update brand color. " + err.message
      );
    }
  }
);
